<app-progress-indicator [inProgress]="isLoading"></app-progress-indicator>
<div class="wetter_content_container">
  <app-messwert-filter (onColumnsChange)="messwertTabelle.updateColumnVisibility($event)"
                       (onFilterChange)="reloadDataWithNewFilter($event)" [isRefreshing]="isLoading">
  </app-messwert-filter>
  <app-messwert-tabelle #messwertTabelle
                        [messwertPakete]="messwertPakete"
                        (reloadData)="refreshData()">
  </app-messwert-tabelle>
</div>
